import userManage from "../views/userManage";

export default [
  {
    path: "/userManage",
    name: "사용자관리",
    component: userManage,
  },
];
